import styled from '@emotion/styled';
import { navigation } from 'src/assets/colors';

export const TabNav = styled('nav', { label: 'TabNav' })`
    background-color: ${navigation.bgColor};
    display: flex;
    justify-content: flex-start;
    margin: 16px 0;
`;

interface TabNavItemPropsType {
    isActive: boolean;
}

export const TabNavItem = styled('button', { label: 'TabNavItem' })<TabNavItemPropsType>`
    background: ${({ isActive }): string => isActive ? '#a3ccb2' : '#bbb'};
    border-radius: 0;
    border: none;
    color: #fff;
    cursor: pointer;
    font-family: var(--fontFamilySecondary);
    font-size: 0.75rem;
    height: 30px;
    line-height: 1.4;
    padding: 4px 8px;
    text-align: center;
    transition: background-color .2s ease;
    &:not(:last-of-type) {
        margin-right: 8px;
    }
`;
